import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c12db3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "LAOT 账号注册", -1))
const _hoisted_3 = { class: "body" }
const _hoisted_4 = { class: "line" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "手机号", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, null, -1))
const _hoisted_7 = { class: "line" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "邮箱", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "请填写真实邮箱地址，否则可能无法找回密码", -1))
const _hoisted_10 = { class: "line" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "密码", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, null, -1))
const _hoisted_13 = { class: "line" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "确认密码", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, null, -1))
const _hoisted_16 = {
  key: 0,
  style: {"display":"flex","flex-direction":"row"}
}
const _hoisted_17 = { class: "btn-group" }

import { ScForm } from '@/models/ScForm';
import { useRouter } from 'vue-router';
import { tokenManager } from '@/util/token';
import { request } from '@/util/request';
import { user } from '@/models/User';
import { addBizRouter } from '@/router';
import ScBtn from '@/components/common/widget/ScBtn.vue';
import VueHcaptcha from '@hcaptcha/vue3-hcaptcha';
import config from '@/config';
import { message } from 'ant-design-vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Register',
  setup(__props) {

const form = new ScForm();
const captcha = ref<InstanceType<typeof VueHcaptcha>>();
form.init();
const router = useRouter();
const data = form.data;
const needCaptcha = ref(false);

async function onVerify(token: string) {
  data.value.code = token;
}

async function submit() {
  if (needCaptcha.value && !data.value.code) {
    message.error('请先完成验证');
    return;
  }

  if (!/^1[0-9]{10}$/.test(form.data.value.username)) {
    message.error("手机号格式不正确")
    return;
  }

  if (form.data.value.password != form.data.value.confirmPassword) {
    message.error("确认密码与密码不一致")
    return;
  }

  const res = await request('/management/login/register', form.data.value, {
    noNeedLogin: true,
    onError: (err) => {
      if (err.type === 'biz') {
        captcha.value?.reset();
      }
    },
  });
  if (res) {
    tokenManager.set(res.token);
    user.set(res.user);
    await addBizRouter();
    const redirect = router.currentRoute.value.query?.redirect;
    const url = typeof redirect === 'string' ? redirect : '/';
    await router.replace(url);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_password = _resolveComponent("a-input-password")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "login-box",
      onKeydown: _withKeys(submit, ["enter"])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_a_input, {
            value: _unref(data).username,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).username) = $event)),
            placeholder: "请输入手机号"
          }, null, 8, ["value"])
        ]),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_a_input, {
            value: _unref(data).email,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(data).email) = $event)),
            placeholder: "请输入邮箱地址"
          }, null, 8, ["value"])
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_a_input_password, {
            value: _unref(data).password,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(data).password) = $event)),
            placeholder: "请输入密码"
          }, null, 8, ["value"])
        ]),
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_a_input_password, {
            value: _unref(data).confirmPassword,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(data).confirmPassword) = $event)),
            placeholder: "请确认密码"
          }, null, 8, ["value"])
        ]),
        _hoisted_15,
        (needCaptcha.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(_unref(VueHcaptcha), {
                ref_key: "captcha",
                ref: captcha,
                onVerify: onVerify,
                sitekey: _unref(config).captchaKey
              }, null, 8, ["sitekey"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(ScBtn, {
          type: "primary",
          handler: submit,
          text: "注册"
        }),
        _createVNode(ScBtn, {
          type: "link",
          text: "已有账号，去登录",
          handler: () => _unref(router).push('/login')
        }, null, 8, ["handler"])
      ])
    ], 32)
  ]))
}
}

})